import styled from 'styled-components'

import Text from '@components/atoms/Text'

export const Root = styled(Text)`
  color: ${(props) => props.theme.palette.default.error};
  margin-bottom: 0;
  margin-top: 0.3125rem;
`
